<script setup lang="ts">
/**
 * Copy of the official Vue Font Awesome component to use when advanced features are not needed.
 * Reduces the size of initial JavaScript chunks by 70 kB (minified)
 */

import type { IconDefinition } from '@fortawesome/fontawesome-common-types';
import '@fortawesome/fontawesome-svg-core/styles.css';
import { onMounted } from 'vue';

const props = defineProps<{
  icon: IconDefinition | ['fak', string];
  size?: string;
  spin?: boolean;
  rotation?: string;
}>();

const emit = defineEmits<{
  (event: 'click'): void;
}>();

onMounted(() => {
  if (
    Array.isArray(props.icon) &&
    !document.querySelector('script[src="https://kit.fontawesome.com/b449f47525.js"]')
  ) {
    const script = document.createElement('script');
    script.src = 'https://kit.fontawesome.com/b449f47525.js';
    script.crossOrigin = 'anonymous';
    document.head.appendChild(script);
  }
});
</script>

<template>
  <i
    v-if="Array.isArray(icon)"
    class="fak"
    :class="{
      [`fa-${icon[1]}`]: true,
      [`fa-${size}`]: !!size,
    }"
  ></i>
  <svg
    v-else
    class="svg-inline--fa"
    :class="{
      [`fa-${size}`]: !!size,
      [`fa-rotate-${rotation}`]: !!rotation,
      'animate-spin': spin,
    }"
    aria-hidden="true"
    focusable="false"
    :data-prefix="icon.prefix"
    :data-icon="icon.iconName"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    :viewBox="`0 0 ${icon.icon[0]} ${icon.icon[1]}`"
    @click="emit('click')"
  >
    <path v-if="typeof icon.icon[4] === 'string'" fill="currentColor" :d="icon.icon[4]" />
    <template v-else>
      <path fill="currentColor" :d="icon.icon[4][0]" />
      <path fill="currentColor" :d="icon.icon[4][1]" />
    </template>
  </svg>
</template>

<style>
.svg-inline--fa.fa-fader {
  color: var(--tml-danger-color);
  display: inline-block;
  -moz-animation: pulse 2s infinite linear;
  -o-animation: pulse 2s infinite linear;
  -webkit-animation: pulse 2s infinite linear;
  animation: pulse 2s infinite linear;
}
@-webkit-keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-moz-keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-o-keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-ms-keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
